export function runOptionalStartup(task: () => unknown): void {
  try {
    const result = task();
    if (result instanceof Promise) {
      void result.catch(() => {
        // Async startup enhancements are optional too. Dynamic imports and
        // browser APIs can reject after React has started mounting; contain
        // those failures instead of surfacing an unhandled rejection.
      });
    }
  } catch {
    // Analytics and 3D boot helpers are optional enhancements. A browser- or
    // extension-specific failure here must not prevent React from mounting the
    // playable application.
  }
}
